import styles from './EmployedsContent.module.scss';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { ReactComponent as IconProblem } from '../../assets/img/Employed/iconProblem.svg';
import { Employed } from 'redux/Api/employedsApi/type';

export const EmployedProblem = ({
  employed,
  screen,
}: {
  employed: Employed;
  screen: string;
}) => {
  let textProblemApp = '';
  let textProblemFns = '';
  let textProblemContract = '';
  let textProblemDeleted = '';
  let textProblemInnStoplist = '';
  if (employed?.is_in_inn_stoplist) {
    textProblemInnStoplist = 'Находится в списке бывших сотрудников';
  }
  if (employed?.is_deleted) {
    textProblemDeleted = 'Профиль удален';
  }
  if (employed?.worker_app?.app_status !== 3) {
    textProblemApp = 'Не зарегистрирован в приложении';
  }
  if (employed?.worker_app?.fns_status !== 1 && employed?.worker_app?.fns_status !== 2) {
    textProblemFns = 'Не подключен к «Мой Налог»';
  }
  if (
    employed?.worker_app?.nationality !== 'Россия' &&
    employed?.unified_contract?.status !== 'signed_by_worker'
  ) {
    textProblemContract = 'Требуется договор';
  }

  const hasProblems = Boolean(
    textProblemApp ||
      textProblemFns ||
      textProblemContract ||
      textProblemDeleted ||
      textProblemInnStoplist,
  );

  if (!hasProblems) {
    return null;
  }

  if (textProblemInnStoplist) {
    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        <div className={styles.icon}>
          <IconProblem />
        </div>
        <div className={styles.textError}>
          <TextWithTooltip
            content={textProblemInnStoplist}
            className={styles.textError}
          />
        </div>
      </div>
    );
  }

  if (screen === 'desktop') {
    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        <div className={styles.icon}>
          <IconProblem />
        </div>
        {employed?.is_deleted ? (
          <>
            {textProblemDeleted && (
              <div className={styles.textError}>
                <div style={{ display: 'flex' }}>
                  <TextWithTooltip
                    content={textProblemDeleted}
                    className={styles.textError}
                  />
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {textProblemApp && (
              <div className={styles.textError}>
                <div style={{ display: 'flex' }}>
                  <TextWithTooltip
                    content={textProblemApp}
                    className={styles.textError}
                  />
                  {(textProblemFns || textProblemContract) && ' ,'}
                </div>
              </div>
            )}
            {textProblemFns && (
              <div className={styles.textError}>
                <div style={{ display: 'flex' }}>
                  <TextWithTooltip
                    content={textProblemFns}
                    className={styles.textError}
                  />
                  {textProblemContract && ' ,'}
                </div>
              </div>
            )}
            {textProblemContract && (
              <div className={styles.textError}>
                <TextWithTooltip
                  content={textProblemContract}
                  className={styles.textError}
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  if (screen === 'mobile' || screen === 'tablet') {
    return (
      <div className={styles.contentError}>
        {employed?.is_deleted ? (
          <>
            {textProblemDeleted && (
              <div className={styles.textError}>
                <div
                  className={styles.lineProblem}
                  style={{ justifyContent: screen === 'mobile' ? 'start' : 'end' }}>
                  <IconProblem />
                  <TextWithTooltip
                    content={textProblemDeleted}
                    className={styles.textError}
                  />
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {textProblemApp && (
              <div className={styles.textError}>
                <div
                  className={styles.lineProblem}
                  style={{ justifyContent: screen === 'mobile' ? 'start' : 'end' }}>
                  <IconProblem />{' '}
                  <TextWithTooltip
                    content={textProblemApp}
                    className={styles.textError}
                  />
                </div>
              </div>
            )}
            {textProblemFns && (
              <div className={styles.textError}>
                <div
                  className={styles.lineProblem}
                  style={{ justifyContent: screen === 'mobile' ? 'start' : 'end' }}>
                  <IconProblem />{' '}
                  <TextWithTooltip
                    content={textProblemFns}
                    className={styles.textError}
                  />
                </div>
              </div>
            )}
            {textProblemContract && (
              <div
                className={styles.lineProblem}
                style={{ justifyContent: screen === 'mobile' ? 'start' : 'end' }}>
                <IconProblem />
                <TextWithTooltip
                  content={textProblemContract}
                  className={styles.textError}
                />
              </div>
            )}
          </>
        )}
      </div>
    );
  }

  return <div />;
};
